module.exports = __webpack_public_path__ + "static/media/TR.c9ece60d.png";